// the delay time of text tooltip
export const TOOLTIP_LONG_DELAY_TIME = 1000;
